export default {
  zh: {
    has_code: '我有优惠码',
    coupon: '优惠码',
    submit: '提交',
    pleaseEnterDiscountCode: '请输入优惠码',
    success_valid: '优惠码验证成功，正在重新计算价格',
    cancel: '取消',
    to_pay: '去支付',
    please_input: '请输入{key}'
  },
  en: {
    has_code: 'I have a coupon',
    coupon: 'Coupon',
    submit: 'Submit',
    pleaseEnterDiscountCode: 'Please enter coupon',
    success_valid: 'Coupon verification successful, recalculating price',
    cancel: 'Cancel',
    to_pay: 'To Pay',
    please_input: 'Please enter {key}'
  },
  ja: {
    has_code: '私はクーポンを持っています',
    coupon: 'クーポン',
    submit: '提出',
    pleaseEnterDiscountCode: 'クーポンを入力してください',
    success_valid: 'クーポンの検証が成功しました、価格の再計算を行います',
    cancel: 'キャンセル',
    to_pay: '支払いに進む',
    please_input: '{key}を入力してください'
  },
  ko: {
    has_code: '나는 쿠폰을 가지고 있습니다',
    coupon: '쿠폰',
    submit: '제출',
    pleaseEnterDiscountCode: '쿠폰을 입력해주세요',
    success_valid: '쿠폰 검증이 성공했습니다, 가격 재계산을 시작합니다',
    cancel: '취소',
    to_pay: '결제로 이동',
    please_input: '{key}를 입력해 주세요'
  },
  tw: {
    has_code: '我有優惠碼',
    coupon: '優惠碼',
    submit: '提交',
    pleaseEnterDiscountCode: '請輸入優惠碼',
    success_valid: '優惠碼驗證成功，正在重新計算價格',
    cancel: '取消',
    to_pay: '去支付',
    please_input: '請輸入{key}'
  },
  pl: {
    has_code: 'Mam kupon',
    coupon: 'Kupon',
    submit: 'Wyślij',
    pleaseEnterDiscountCode: 'Proszę wprowadzić kod rabatowy',
    success_valid: 'Kod rabatowy został zweryfikowany, przeliczanie ceny',
    cancel: 'Anuluj',
    to_pay: 'Do zapłaty',
    please_input: 'Wprowadź {key}'
  },
  es: {
    has_code: 'Tengo un cupón',
    coupon: 'Cupón',
    submit: 'Enviar',
    pleaseEnterDiscountCode: 'Ingrese el cupón',
    success_valid: 'El cupón ha sido verificado correctamente, recalculando el precio',
    cancel: 'Cancelar',
    to_pay: 'Ir al pago',
    please_input: 'Introduce {key}'
  },
  fr: {
    has_code: 'J\'ai un coupon',
    coupon: 'Coupon',
    submit: 'Soumettre',
    pleaseEnterDiscountCode: 'Veuillez entrer le coupon',
    success_valid: 'Le coupon a été vérifié avec succès, recalcul du prix',
    cancel: 'Annuler',
    to_pay: 'Aller au paiement',
    please_input: 'Veuillez entrer {key}'
  },
  de: {
    has_code: 'Ich habe einen Coupon',
    coupon: 'Coupon',
    submit: 'Absenden',
    pleaseEnterDiscountCode: 'Bitte geben Sie den Coupon ein',
    success_valid: 'Der Coupon wurde erfolgreich überprüft, Preis wird neu berechnet',
    cancel: 'Abbrechen',
    to_pay: 'Zur Zahlung gehen',
    please_input: 'Bitte geben Sie {key} ein'
  },
  ru: {
    has_code: 'У меня есть купон',
    coupon: 'Купон',
    submit: 'Отправить',
    pleaseEnterDiscountCode: 'Пожалуйста, введите код скидки',
    success_valid: 'Код скидки успешно проверен, пересчитываем цену',
    cancel: 'Отмена',
    to_pay: 'Перейти к оплате',
    please_input: 'Пожалуйста, введите {key}'
  },
  pt: {
    has_code: 'Eu tenho um cupom',
    coupon: 'Cupom',
    submit: 'Enviar',
    pleaseEnterDiscountCode: 'Insira o cupom',
    success_valid: 'O cupom foi verificado com sucesso, preço está sendo recalculado',
    cancel: 'Cancelar',
    to_pay: 'Ir para o pagamento',
    please_input: 'Insira {key}'
  },
  it: {
    has_code: 'Ho un coupon',
    coupon: 'Coupon',
    submit: 'Invia',
    pleaseEnterDiscountCode: 'Inserisci il coupon',
    success_valid: 'Il coupon è stato verificato con successo, prezzo viene ricalcolato',
    cancel: 'Annulla',
    to_pay: 'Vai al pagamento',
    please_input: 'Inserisci {key}'
  },
  ar: {
    has_code: 'لدي قسيمة',
    coupon: 'قسيمة',
    submit: 'إرسال',
    pleaseEnterDiscountCode: 'يرجى إدخال رمز الخصم',
    success_valid: 'تم التحقق من رمز الخصم بنجاح، جاري إعادة حساب السعر',
    cancel: 'إلغاء',
    to_pay: 'الذهاب إلى الدفع',
    please_input: 'يرجى إدخال {key}'
  },
  th: {
    has_code: 'ฉันมีคูปอง',
    coupon: 'คูปอง',
    submit: 'ส่ง',
    pleaseEnterDiscountCode: 'กรุณาใส่รหัสส่วนลด',
    success_valid: 'ตรวจสอบรหัสส่วนลดสำเร็จ กำลังคำนวณราคาใหม่',
    cancel: 'ยกเลิก',
    to_pay: 'ไปยังการชำระเงิน',
    please_input: 'กรุณากรอก {key}'
  },
  da: {
    has_code: 'Jeg har en kupon',
    coupon: 'Kupon',
    submit: 'Indsend',
    pleaseEnterDiscountCode: 'Indtast venligst rabatkoden',
    success_valid: 'Rabatkoden er bekræftet, genberegner prisen',
    cancel: 'Annuller',
    to_pay: 'Gå til betaling',
    please_input: 'Indtast venligst {key}'
  },
  no: {
    has_code: 'Jeg har en kupong',
    coupon: 'Kupong',
    submit: 'Send inn',
    pleaseEnterDiscountCode: 'Vennligst skriv inn rabattkoden',
    success_valid: 'Rabattkoden er bekreftet, beregner prisen på nytt',
    cancel: 'Avbryt',
    to_pay: 'Gå til betaling',
    please_input: 'Vennligst skriv inn {key}'
  },
  nl: {
    has_code: 'Ik heb een coupon',
    coupon: 'Coupon',
    submit: 'Verzenden',
    pleaseEnterDiscountCode: 'Voer de kortingscode in',
    success_valid: 'Kortingscode is geverifieerd, prijs wordt opnieuw berekend',
    cancel: 'Annuleren',
    to_pay: 'Ga naar betaling',
    please_input: 'Voer {key} in'
  },
  id: {
    has_code: 'Saya punya kupon',
    coupon: 'Kupon',
    submit: 'Kirim',
    pleaseEnterDiscountCode: 'Silakan masukkan kode diskon',
    success_valid: 'Kode diskon berhasil diverifikasi, menghitung ulang harga',
    cancel: 'Batal',
    to_pay: 'Pergi ke pembayaran',
    please_input: 'Silakan masukkan {key}'
  },
  tr: {
    has_code: 'Kuponum var',
    coupon: 'Kupon',
    submit: 'Gönder',
    pleaseEnterDiscountCode: 'Lütfen indirim kodunu girin',
    success_valid: 'İndirim kodu doğrulandı, fiyat yeniden hesaplanıyor',
    cancel: 'İptal',
    to_pay: 'Ödemeye git',
    please_input: 'Lütfen {key} girin'
  },

}